import { render } from "./ServiciosList.vue?vue&type=template&id=7cdc0b2b&scoped=true"
import script from "./ServiciosList.vue?vue&type=script&lang=js"
export * from "./ServiciosList.vue?vue&type=script&lang=js"

import "./ServiciosList.vue?vue&type=style&index=0&id=7cdc0b2b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdc0b2b"]])

export default __exports__